/**
 * Parent theme js imports (Declare only needed js files)
 */

import './../../../../w-theme/ui/assets/js/settings';
import './../../../../w-theme/ui/assets/js/components/SideMenu/init';
import './ScrollAnimation/init';
import './Slider/init';
import './Video/init';
import './SideMenu/init';
import './LineBackdrop/init';
import './NativeVideo/init';
import './ProjectsFilter/init';
import './MovingEye/init';
import './Modal/init';
import './ServicesPresentation/init';




// WEBPACK FOOTER //
// ./ui/assets/js/app.js